import React from "react";
import ErrorField from "./error";
import { TextField } from "components/support";
import { observer } from "mobx-react";

const CestField = ({ errors, row, onChange }) => {
  const { taxes } = row;
  const foundErrors = errors.find(v => v.name === row.name);
  const hasErrors =
    foundErrors &&
    !!foundErrors.errors &&
    !!foundErrors.errors.taxes &&
    !!foundErrors.errors.taxes.cest;

  return (
    <div>
      <TextField
        value={taxes.cest}
        onChange={(_, value) => onChange(value.replace(/\D/g, ""))}
        fullWidth
      />
      {hasErrors && <ErrorField error={foundErrors.errors.taxes.cest} />}
    </div>
  );
};

export default observer(CestField);



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/cest.js